<template>
  <div class="workplace-container">
    <div class="workplace-header">
      <div class="header-content">
        <div class="welcome-section">
          <div class="welcome-text">
            <h1>{{ timeFix }}，{{ userName }}</h1>
            <p>欢迎使用检测检查数据仪表盘系统</p>
          </div>
          <div class="header-time">
            <div class="time-value">{{ currentTime }}</div>
            <div class="time-date">{{ currentDate }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="workplace-body">
      <div class="stats-section">
        <div class="stats-grid">
          <div
            class="stat-card"
            v-for="(stat, index) in statsData"
            :key="index"
          >
            <div class="stat-icon" :style="{ background: stat.color }">
              <i :class="stat.icon"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ stat.value }}</div>
              <div class="stat-label">{{ stat.label }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-content">
        <div class="quick-nav-card">
          <div class="card-header">
            <h3><i class="el-icon-s-platform"></i> 便捷导航</h3>
          </div>
          <div class="nav-grid">
            <div
              class="nav-item"
              v-for="(item, index) in InfoData"
              :key="index"
              @click="toNext(item.path)"
            >
              <div class="nav-icon" :style="{ background: item.color }">
                <i :class="item.icon" class="iconfont"></i>
              </div>
              <div class="nav-title">{{ item.title }}</div>
            </div>
          </div>
        </div>

        <div class="keywords-card">
          <div class="card-header">
            <h3><i class="el-icon-price-tag"></i> 关键词</h3>
          </div>
          <div class="keywords-content">
            <el-tag v-for="tag in dynamicTags" :key="tag">
              {{ tag }}
            </el-tag>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { timeFix } from '@/utils/time'
import { brequest } from '@/utils/brequest'
import { mapState } from 'vuex'
import { getDeviceTotalCount } from '@/api/detection'
import { getInpectDeviceCount } from '@/api/inspect'

export default {
  computed: {
    ...mapState({
      menus: (state) => state.auths.menus
    })
  },
  data() {
    return {
      timeFix: timeFix(),
      userInfo: {},
      userName: '',
      currentTime: '',
      currentDate: '',
      dynamicTags: ['天宙检测', '检测仪表盘', '检查仪表盘', '数据统计'],
      inputVisible: false,
      inputValue: '',
      InfoData: [
        {
          title: '检测业务仪表盘',
          icon: 'icon-gongzuotongji',
          color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          path: '/detection'
        },
        {
          title: '检查业务仪表盘',
          icon: 'icon-shebeiOEE',
          color: 'linear-gradient(135deg, #19be6b 0%, #18b566 100%)',
          path: '/inspect'
        }
      ],
      statsData: [
        {
          icon: 'el-icon-s-data',
          value: '-',
          label: '检测总数',
          color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        },
        {
          icon: 'el-icon-s-check',
          value: '-',
          label: '检查总数',
          color: 'linear-gradient(135deg, #19be6b 0%, #18b566 100%)'
        }
      ]
    }
  },
  created() {
    this.updateTime()
    setInterval(this.updateTime, 1000)
    this.fetchStatsData()
  },
  methods: {
    async fetchStatsData() {
      try {
        const detectionRes = await getDeviceTotalCount({})
        if (
          detectionRes &&
          detectionRes.data &&
          detectionRes.data.totalCount !== undefined
        ) {
          this.statsData[0].value =
            detectionRes.data.totalCount.toLocaleString()
        }
      } catch (e) {
        console.error('获取检测总数失败', e)
      }

      try {
        const inspectRes = await getInpectDeviceCount({})
        if (
          inspectRes &&
          inspectRes.data &&
          inspectRes.data.count !== undefined
        ) {
          this.statsData[1].value = inspectRes.data.count.toLocaleString()
        }
      } catch (e) {
        console.error('获取检查总数失败', e)
      }
    },
    updateTime() {
      const now = new Date()
      const hours = now.getHours().toString().padStart(2, '0')
      const minutes = now.getMinutes().toString().padStart(2, '0')
      const seconds = now.getSeconds().toString().padStart(2, '0')
      this.currentTime = `${hours}:${minutes}:${seconds}`

      const year = now.getFullYear()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      const day = now.getDate().toString().padStart(2, '0')
      const weekDays = [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六'
      ]
      const weekDay = weekDays[now.getDay()]
      this.currentDate = `${year}年${month}月${day}日 ${weekDay}`
    },
    toNext(path) {
      let isAuth = this.menus[0].subMenus.find((menu) => menu.link === path)
      if (!isAuth) {
        this.jump('/404')
      } else {
        this.jump(path)
      }
    },
    async queryUserInfo() {
      let userInfo = await brequest({
        url: '/user/queryUserInfo',
        method: 'post'
      })
      this.userInfo = userInfo
      this.userName = userInfo.userName
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    }
  },
  async mounted() {
    this.queryUserInfo()
  }
}
</script>

<style lang="scss" scoped>
.workplace-container {
  min-height: 100%;
  background: #f0f2f5;
}

.workplace-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 30px 40px;
  color: #fff;

  .header-content {
    max-width: 1400px;
    margin: 0 auto;
  }

  .welcome-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .welcome-text {
    h1 {
      font-size: 28px;
      font-weight: 600;
      margin-bottom: 8px;
    }

    p {
      font-size: 14px;
      opacity: 0.8;
    }
  }

  .header-time {
    text-align: right;

    .time-value {
      font-size: 36px;
      font-weight: 700;
      letter-spacing: 2px;
    }

    .time-date {
      font-size: 14px;
      opacity: 0.8;
      margin-top: 5px;
    }
  }
}

.workplace-body {
  max-width: 1400px;
  margin: -30px auto 0;
  padding: 0 40px 40px;
}

.stats-section {
  margin-bottom: 24px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  max-width: 800px;
}

.stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }

  .stat-icon {
    width: 60px;
    height: 60px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    color: #fff;
  }

  .stat-info {
    .stat-value {
      font-size: 28px;
      font-weight: 700;
      color: #333;
    }

    .stat-label {
      font-size: 14px;
      color: #999;
      margin-top: 4px;
    }
  }
}

.main-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 800px;
}

.quick-nav-card,
.keywords-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.card-header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;

  h3 {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    display: flex;
    align-items: center;
    gap: 8px;

    i {
      color: #667eea;
    }
  }
}

.nav-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 20px;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #f0f2f5;
    transform: translateY(-2px);

    .nav-icon {
      transform: scale(1.1);
    }
  }

  .nav-icon {
    width: 60px;
    height: 60px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    color: #fff;
    transition: transform 0.3s ease;
  }

  .nav-title {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
}

.keywords-content {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .el-tag {
    border-radius: 16px;
    padding: 0 12px;
    height: 28px;
    line-height: 26px;
    background: linear-gradient(
      135deg,
      rgba(102, 126, 234, 0.1) 0%,
      rgba(118, 75, 162, 0.1) 100%
    );
    border: 1px solid rgba(102, 126, 234, 0.3);
    color: #667eea;
  }
}

@media (max-width: 768px) {
  .workplace-header {
    padding: 20px;

    .welcome-text h1 {
      font-size: 22px;
    }

    .header-time .time-value {
      font-size: 24px;
    }
  }

  .workplace-body {
    padding: 0 20px 20px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .nav-grid {
    grid-template-columns: 1fr;
  }
}
</style>
